import * as types from './types';

const normalizeTimestamp = (dateValue) => {
  if (!dateValue) {
    return null;
  }
  if (dateValue instanceof Date) {
    return dateValue.getTime();
  }
  const parsedTimestamp = new Date(dateValue).getTime();
  return Number.isNaN(parsedTimestamp)
    ? null
    : parsedTimestamp;
};

export const initializePlannerUi = ({
  defaultView,
  defaultCalendarView,
} = {}) => ({
  type: types.INITIALIZE_PLANNER_UI,
  payload: {
    defaultView,
    defaultCalendarView,
  },
});

export const setPlannerCurrentView = (currentView) => ({
  type: types.SET_PLANNER_CURRENT_VIEW,
  currentView,
});

export const setPlannerWeekStyle = (weekStyle) => ({
  type: types.SET_PLANNER_WEEK_STYLE,
  weekStyle,
});

export const setPlannerGridView = (gridView) => ({
  type: types.SET_PLANNER_GRID_VIEW,
  gridView,
});

export const setPlannerShowReminders = (showReminders) => ({
  type: types.SET_PLANNER_SHOW_REMINDERS,
  showReminders,
});

export const setPlannerCalendarView = (calendarView) => ({
  type: types.SET_PLANNER_CALENDAR_VIEW,
  calendarView,
});

export const setPlannerStartDate = (startDate) => ({
  type: types.SET_PLANNER_START_DATE,
  startDate: normalizeTimestamp(startDate),
});

export const setPlannerEndDate = (endDate) => ({
  type: types.SET_PLANNER_END_DATE,
  endDate: normalizeTimestamp(endDate),
});
